<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/68njI1/tc-custom/9781614752066.jpg?1703646800536" alt="This image is the cover for the book Come Nineveh, Come Tyre, Advise and Consent"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Come Nineveh, Come Tyre, Advise and Consent
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In one of two possible ends to the Pulitzer Prize–winning thriller series, the US president faces threats from half-way around the world—and much closer.</b></p><p> The Advise and Consent series is a landmark of political fiction, displaying a depth of insider Washington knowledge and a canvas of compelling characters that catapulted each novel to the top of the bestseller lists. </p><p> At the end of the previous novel, <i>Preserve and Protect</i>, an assassin’s bullet rings out, and we are left to wonder who was killed. Was it the Liberal Vice President Ted Jason, or staunch Conservative Presidential Candidate Orrin Knox? The answer to that question was so large that Pulitzer Prize–winner Drury had to write two novels, each exploring the full ramifications of one of two outcomes . . . </p><p> In <i>Come Nineveh, Come Tyre</i>, China and the Soviet Union are waiting and watching for any sign of weakness from the untried Ted Jason, survivor of the assassination attempt that took the life of Orrin Knox and propelled him into the presidency. But now that he is in this position of power, is he up to the challenge of leadership in such a time of crisis? Or will he bend too far toward appeasement, at the cost of freedom around the world? </p> Looking at the stakes for the United States against the backdrop of war, politics, and scandal, President Jason must play winner-take-all in this game of politics.&lt;/ 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Allen Drury
      </h2>
      
      <p class="authorDescription body article">Allen Drury is a master of political fiction, #1 New York Times bestseller and Pulitzer Prize winner, best known for the landmark novel ADVISE AND CONSENT. A 1939 graduate of Stanford University, Allen Drury wrote for and became editor of two local California newspapers. While visiting Washington, DC, in 1943 he was hired by the United Press (UPI) and covered the Senate during the latter half of World War II. After the war he wrote for other prominent publications before joining the New York Times' Washington Bureau, where he worked through most of the 1950s. After the success of ADVISE AND CONSENT, he left journalism to write full time. He published twenty novels and five works of non-fiction, many of them best sellers. WordFire Press will be reissuing the majority of his works.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Word Fire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00702178